import * as Actions from './actions';
import { initialState } from '../store/initialState';

export const MainPageReducer = (
    state = initialState.mainpage,
    action
) => {
    switch(action.type) {
        case Actions.FETCH_PROVERB:
            return {
                ...state,
                todayProverb: action.payload
            };
        case Actions.FETCH_COUNTER:
            return {
                ...state,
                counter: action.payload
            };
        default:
            return state
    }
}